import { OrganizationInvitationsState } from "@idw-types/state/organization-invitations-state";
import { OrganizationInvitationsActionTypes, OrganizationInvitationsActions } from "../actions/organization-invitations-actions";

export const initialOrganizationInvitationsState: OrganizationInvitationsState = {
    organizationInvitations: {
        isLoading: false,
        organizationInvitations: null,
    }
};

export const organizationInvitationsReducer = (
    state: OrganizationInvitationsState = initialOrganizationInvitationsState,
    action: OrganizationInvitationsActions
): OrganizationInvitationsState => {
    switch (action.type) {
        // Organization Invitations
        case OrganizationInvitationsActionTypes.SET_ORGANIZATION_INVITATIONS_LOADING:
            return {
                ...state,
                organizationInvitations: {
                    ...(action.payload.isLoading
                        ? { ...initialOrganizationInvitationsState.organizationInvitations }
                        : { ...state.organizationInvitations }),
                    isLoading: action.payload.isLoading
                }
            };
        case OrganizationInvitationsActionTypes.SET_ORGANIZATION_INVITATIONS:
            return {
                ...state,
                organizationInvitations: {
                    ...state.organizationInvitations,
                    organizationInvitations: action.payload.axnAdminUserInvitations,
                    isLoading: false
                }
            };
        default:
            return state;
    }
};